import { render, staticRenderFns } from "./StatisticDetails.vue?vue&type=template&id=7cd6cbc5&scoped=true"
import script from "./StatisticDetails.vue?vue&type=script&lang=js"
export * from "./StatisticDetails.vue?vue&type=script&lang=js"
import style0 from "./StatisticDetails.vue?vue&type=style&index=0&id=7cd6cbc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd6cbc5",
  null
  
)

export default component.exports